/**
 * 라우트 접근 가드 — URL 직접 접근 시 권한 없음 화면을 표시한다.
 *
 * ⚠️ 이 가드는 UX용이다. 프론트 라우트 차단만으로는 보안이 되지 않으며,
 * 실제 데이터 보호는 백엔드 API의 permission 검증이 담당해야 한다.
 * (TODO: backend permission 연동 PR에서 처리)
 */
import React from 'react';
import { useSession } from './SessionContext';
import { canAccessItem } from './check';
import AccessDenied from '../components/AccessDenied';

const RequireAccess = ({ item, children }) => {
  const { session } = useSession();

  if (!canAccessItem(session, item)) {
    return <AccessDenied item={item} />;
  }
  return children;
};

export default RequireAccess;
